import { Route } from 'src/routes/Route'

export const CampaignStoreRoute = Route({
  path: 'store/:categoryId',
  init: (categoryId?: string) => ({ categoryId }),
  fromPath: ({ categoryId }) => ({ categoryId }),
})

export type CampaignStoreRoute = Route<typeof CampaignStoreRoute>
